import {FileOpen} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import {getValueOrDash} from "../../../helpers/defaultReturnFunction";
import {impexDateFormat} from "../../../manager/dateManager";
import {dateType} from "./fields";

const grnTableCustomCell = ({
  value,
  column: {id},
  row: {original},
  handleGRNModalOpen,
}) => {
  if (value) {
    if (dateType.includes(id)) {
      return impexDateFormat(value);
    } else if (id === "QCRemarks") {
      if (value === "Qc Done") {
        return "QC Approved";
      }
    } else return `${value}`;
  } else {
    if (id === "QCRemarks") {
      return "QC Pending";
    } else if (id === "view") {
      return (
        <IconButton
          color="error"
          sx={{
            ml: 1,
            mr: 1,
            p: "2px",
          }}
          onClick={() => handleGRNModalOpen(original)}
        >
          <FileOpen fontSize="small" color="error" />
        </IconButton>
      );
    }
    return `${getValueOrDash(value)}`;
  }
};

export const grnDefaultColumn = {
  Cell: grnTableCustomCell,
};
